import VolunteerPreferences from "models/resource-management/volunteers/volunteer-preferences";
import Gender from "../gender";
import Account from "./account";
import Address from "./address";
import Credential from "./credential";
import EmployeeDetail from "./employee-detail";
import PhoneNumber from "./phone-number";
import ScheduleDetail from "./schedule-detail";

export default class CompanyResource {
  resourceType: number;
  id: number;
  externalId: number;
  tenantId: number;
  professionalRelation: number;
  isEmployee: boolean;
  isPhysician: boolean;
  groupAffiliation: string;
  dateOfBirth: string;
  gender: Gender;
  primaryLanguage?: string;
  resourceStatus: number;
  firstName: string;
  lastName: string;
  middleInitial?: string;
  preferredName?: string;
  displayName: string;
  emailAddress: string;
  addresses?: Address[];
  phoneNumbers?: PhoneNumber[];
  notes?: string;
  employeeInformation?: EmployeeDetail;
  credentials?: Credential[];
  npi: string;
  dea: string;
  taxonomyCode: string;
  taxId: string;
  attachedToPatients: boolean;
  volunteerType?: number;
  trainingCompletionDate?: string;
  skillsAndInterests?: number[];
  schedules?: ScheduleDetail[];
  preferences?: VolunteerPreferences;
  account?: Account;
  languages?: number[];
  userId: string;
}



// WEBPACK FOOTER //
// ./src/models/company-resources/companyResource.ts